var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "user"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {}, [_c('legend', [_vm._v("Bulk Transit Lost Mark")]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.searchTransitApprovalData()
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Bag No :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.bagno),
      expression: "bagno"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('bagno')
    },
    staticStyle: {},
    attrs: {
      "id": "bagno",
      "type": "text",
      "name": "bagno",
      "placeholder": "Enter Bag No."
    },
    domProps: {
      "value": (_vm.bagno)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bagno = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.bagno')),
      expression: "errors.has('form-1.bagno')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Enter Bag Number")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "btn btn-success btn-sm",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")]), _vm._v(" \n                  "), _c('button', {
    staticClass: "btn btn-danger btn-sm",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reset")])])], 1)])]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isSearchLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isSearchLoading = $event
      }
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowing),
      expression: "isShowing"
    }],
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('hr'), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post",
      "data-vv-scope": "form-1"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateForm('form-1')
      }
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', [_c('span', {
    staticStyle: {
      "color": "blue"
    }
  }, [_vm._v("Total Record: " + _vm._s(_vm.totalRecord) + " "), _c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("Total Selected : " + _vm._s(_vm.selectedCount))])])]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lostDebitCheckAll),
      expression: "lostDebitCheckAll"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.lostDebitCheckAll) ? _vm._i(_vm.lostDebitCheckAll, null) > -1 : (_vm.lostDebitCheckAll)
    },
    on: {
      "click": function($event) {
        return _vm.selectItems($event)
      },
      "change": function($event) {
        var $$a = _vm.lostDebitCheckAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.lostDebitCheckAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.lostDebitCheckAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.lostDebitCheckAll = $$c
        }
      }
    }
  })]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10)])]), _vm._v(" "), _c('tbody', _vm._l((_vm.lostBagShipments), function(shipmentdata) {
    return _c('tr', [_c('td', [_c('div', {
      staticClass: "checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedItems),
        expression: "selectedItems"
      }],
      attrs: {
        "type": "checkbox",
        "id": shipmentdata.ShippingID
      },
      domProps: {
        "value": shipmentdata.ShippingID,
        "checked": Array.isArray(_vm.selectedItems) ? _vm._i(_vm.selectedItems, shipmentdata.ShippingID) > -1 : (_vm.selectedItems)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.selectedItems,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = shipmentdata.ShippingID,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedItems = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedItems = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedItems = $$c
          }
        }, function($event) {
          return _vm.calculateDebitAmout(("" + (shipmentdata.ShippingID)))
        }]
      }
    })])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shipmentdata.ClientName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shipmentdata.ShippingID))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(shipmentdata.OriginHubName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shipmentdata.FinalDestinationName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shipmentdata.CurrentHubName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shipmentdata.Status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shipmentdata.ShipmentStatus))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("setValidNumber")(shipmentdata.NetPayment)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("setValidNumber")(shipmentdata.OctroiMRP)))])])
  }), 0)]), _c('br')], 1), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post",
      "data-vv-scope": "form-2"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateForm2('form-2')
      }
    }
  }, [_c('b-input-group', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipmentList),
      expression: "shipmentList"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('shipmentList')
    },
    attrs: {
      "id": "shipmentList",
      "type": "hidden",
      "name": "shipmentList"
    },
    domProps: {
      "value": (_vm.shipmentList)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipmentList = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.shipmentList')),
      expression: "errors.has('form-2.shipmentList')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please select above list")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(11), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-1"
  }, [_c('label', [_vm._v(_vm._s(_vm.TotalNetAmt))])]), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v(_vm._s(_vm.TotaloctroAmt))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(13), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v(_vm._s(_vm.TotalDebitAmount))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(14), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.debitFrom),
      expression: "debitFrom"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('debitFrom')
    },
    attrs: {
      "id": "debitFrom",
      "name": "debitFrom"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.debitFrom = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.DebitFromData]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("-- Select Debit From --")]), _vm._v(" "), _vm._l((_vm.debitFromObj), function(debitFrom_Obj) {
    return _c('option', {
      domProps: {
        "value": debitFrom_Obj.Id
      }
    }, [_vm._v(_vm._s(debitFrom_Obj.Name))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.debitFrom')),
      expression: "errors.has('form-2.debitFrom')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Enter select debitFrom.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(15), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.debitTo),
      expression: "debitTo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('debitTo')
    },
    attrs: {
      "id": "debitTo",
      "name": "debitTo"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.debitTo = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("-- Select Debit To --")]), _vm._v(" "), _vm._l((_vm.debitToObj), function(debitTo_Obj) {
    return _c('option', {
      domProps: {
        "value": {
          id: debitTo_Obj.Id,
          text: debitTo_Obj.Name
        }
      }
    }, [_vm._v(_vm._s(debitTo_Obj.Name))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.debitTo')),
      expression: "errors.has('form-2.debitTo')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Enter select debitTo.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(16), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.DocketNumber),
      expression: "DocketNumber"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('DocketNumber')
    },
    attrs: {
      "id": "DocketNumber",
      "type": "text",
      "name": "DocketNumber",
      "placeholder": "Please Enter Docket Number"
    },
    domProps: {
      "value": (_vm.DocketNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.DocketNumber = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.DocketNumber')),
      expression: "errors.has('form-2.DocketNumber')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Enter Docket Number.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(17), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-4",
    staticStyle: {
      "display": "block"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comments),
      expression: "comments"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    ref: "textarea",
    staticClass: "col-md-12",
    class: {
      'form-control': true,
      'error': _vm.errors.has('comments')
    },
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "rows": "4",
      "name": "comments",
      "id": "comments",
      "maxlength": _vm.max
    },
    domProps: {
      "value": (_vm.comments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comments = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "textarea-style",
    staticStyle: {
      "display": "block",
      "color": "blue"
    }
  }, [_vm._v(" Maximum length 500/" + _vm._s((_vm.max - _vm.comments.length)) + " Characters. ")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.comments')),
      expression: "errors.has('form-2.comments')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Enter Comments.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "col-md-2"
  }), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-6",
    staticStyle: {
      "display": "block"
    }
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v(" Save ")]), _vm._v(" "), _c('span', {
    staticClass: "btn btn-sm btn-danger",
    on: {
      "click": _vm.reset
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v("Reset")])]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isSaveLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isSaveLoading = $event
      }
    }
  })], 1)])], 1)])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "header"
  }, [_vm._v(" "), _c('b', [_vm._v("Lost Debit Shipments List ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("ClientName")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("ShippingID")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("BagNo")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Origin")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Destination")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("CurrentHub")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Status")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("ShipmentStatus")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("NetPayment")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("OctroiMRP")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-2"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v(" Total Net Amount : ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-2"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v(" Total Octroi Amount : ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-2"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v(" Debit Amount: ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-2"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v(" Debit From : ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-2"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v(" Debit To : ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-2"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v(" Docket Number : ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-2"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v(" Comments : ")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-559dab2a","hasScoped":true}!./src/views/components/LOST/BulkTransitLostMark/BulkTransitLostMark.component.html
// module id = 1111
// module chunks = 1